<script lang="ts">
    import {modal} from 'general/store';
    import {fade} from 'svelte/transition';

    import {ANIMATION_DURATION, STATE, TEMPLATE} from 'general/constants';
    import MainSide from 'desktop/templates/squareAdaExitModal/state/main/MainSide.svelte';
    import CloseButton from 'general/components/closeButton/CloseButton.svelte';
    import Theme from 'general/theme/Theme.svelte';
    import Position from 'desktop/components/position/Position.svelte';
    import Backdrop from 'general/components/backdrop/Backdrop.svelte';

    import s from './style.module.css';

    let isLoadChat = false;

    // save gusa ada settings
    const GUSA_ADA_OPTIONS = window.adaSettings;

    if (window.adaEmbed && GUSA_ADA_OPTIONS) {
        window.adaEmbed.stop();
    }

    const OPTIONS = {
        [STATE.MAIN]: {component: MainSide, props: {GUSA_ADA_OPTIONS}},
    } as const;
</script>

{#if GUSA_ADA_OPTIONS}
    <div transition:fade|global={{duration: ANIMATION_DURATION.MODAL}}>
        <Position>
            <Theme template={TEMPLATE.SQUARE_EXIT}>
                <div class={s.wrapper}>
                    <svelte:component
                        this={OPTIONS[$modal.state].component}
                        {...OPTIONS[$modal.state].props}
                        bind:isLoadChat
                    />
                    {#if isLoadChat}
                        <CloseButton
                            handleClick={modal.close}
                            theme={TEMPLATE.SQUARE_EXIT}
                            crossColor={'#898989'}
                            delay={3}
                            size={12}
                        />
                    {/if}
                </div>
            </Theme>
        </Position>
        {#if isLoadChat}
            <Backdrop />
        {/if}
    </div>
{/if}
